import React, { lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { FinancierFeatureRoute } from 'components/AuthenticatedArea';

const Vencimento = lazy(() => import('./Arrecadacao/Vencimento'));
const Cobranca = lazy(() => import('./Arrecadacao/Cobranca'));
const AdvanceLimit = lazy(() => import('./GestaoLimite/AdvanceLimit'));
const GuaranteeNeed = lazy(() => import('./GestaoLimite/GuaranteeNeed'));
const GuaranteePanel = lazy(() => import('views/dashboard/private/GuaranteePanel'));
const FileManagementPage = lazy(() => import('views/dashboard/private/FileDashboard/FileManagement'));
const FileDashboard = lazy(() => import('views/dashboard/private/FileDashboard'));

const FinancierRoutes = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="arrecadacao/vencimento" replace />} />

      <Route element={<FinancierFeatureRoute featureKey="arrecadacao" />}>
        <Route path="arrecadacao/vencimento" element={<Vencimento />} />
        <Route path="arrecadacao/cobranca" element={<Cobranca />} />
      </Route>

      <Route element={<FinancierFeatureRoute featureKey="gestaoLimite" />}>
        <Route path="gestao-limite" element={<AdvanceLimit />} />
        <Route path="gestao-limite/necessidade-garantia" element={<GuaranteeNeed />} />
      </Route>

      <Route element={<FinancierFeatureRoute featureKey="reports" />}>
        <Route path="relatorios/painel-garantia" element={<GuaranteePanel />} />
      </Route>

      <Route element={<FinancierFeatureRoute featureKey="file" />}>
        <Route path="documentacao" element={<FileDashboard />}>
          <Route index element={<Navigate to="gerenciamento" replace />} />
          <Route path="gerenciamento" element={<FileManagementPage />} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="arrecadacao/vencimento" replace />} />
    </Routes>
  );
};

export default FinancierRoutes;
